import { ApolloLink } from '@apollo/client'

const URL_PATH_PARAM_TO_HEADER_MAP = {
  partners: 'X-IPP-Partner-Ids',
}

/**
 * Returns the path param value from a list of path params
 * Returns null if the path param does not exist or if there is 
 * no value proceeding the path key
 */
const getPathParamValue = (params: string[], pathParam: string) => {
  const pathParamIndex = params.indexOf(pathParam)
  if (pathParamIndex === -1 || pathParamIndex + 1 >= params.length) {
    return null
  }

  return params[pathParamIndex + 1]
}

/**
 * This ApolloLink adds path params to the GraphQL operation context
 *
 * Path param keys defined in URL_PATH_PARAM_TO_HEADER_MAP will have their values
 * added to the GraphQL request headers. E.g for the pathname /partners/123, the GraphQL
 * request header will include the key X-IPP-Partner-Ids with the value ['123']
 */
export const pathParamsLink = new ApolloLink((operation, forward) => {
  const urlLocation = window?.location?.pathname
  if (!urlLocation) {
    return forward(operation)
  }

  const pathParams = urlLocation.replace(/^\//, '').split('/')
  const context = operation.getContext()
  const additionalContextArgs: Record<string, string[]> = {}

  for (const [pathParam, headerKey] of Object.entries(URL_PATH_PARAM_TO_HEADER_MAP)) {
    const value = getPathParamValue(pathParams, pathParam)
    if (value != null) {
      additionalContextArgs[headerKey] = [value]
    }
  }

  operation.setContext({
    ...context,
    headers: { ...context.headers, ...additionalContextArgs },
  })

  return forward(operation)
})
